export default __webpack_public_path__ + "static/media/pattern_normal.ce2a2206.png";